import { Component, Input } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { currencyPipe } from '@ipreo/muni-shared';
import { GameDayRootReducerState } from '../../../../state/root.state';
import { getGamedayDealState } from '../../../../state/data/reducer';
import { GameDayModel } from '../../../../models/gameday-model';

@Component({
  selector: 'muni-gameday-gameday-header-title',
  template: '<div title="{{label | async}}">{{label | async}}<div>',
  styleUrls: ['./title.styles.scss'],
  standalone: false,
})
export class HeaderTitleComponent {
  @Input()
  public section: string;

  public readonly label: Observable<string> = this.store.pipe(
    select(getGamedayDealState),
    map((deal: GameDayModel.Deal) => {
      let description: string;

      if (deal) {
        description = `${currencyPipe.transform(
          deal.size,
          'USD',
          'symbol',
          '1.0-0'
        )} ${deal.description}`;
      } else {
        description = 'Loading...';
      }

      if (this.section) {
        description = `${description} | ${this.section}`;
      }

      return description;
    })
  );

  constructor(private store: Store<GameDayRootReducerState>) {}
}
